import { render, staticRenderFns } from "./Biometrics.vue?vue&type=template&id=2d5779bd"
import script from "./Biometrics.vue?vue&type=script&lang=js"
export * from "./Biometrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports